import { connect } from 'react-redux';
import { createToolbarEvent } from '../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../analytics/functions';
import { translate } from '../../base/i18n/functions';
import { IconScreenshare } from '../../base/icons/svg';
import AbstractButton from '../../base/toolbox/components/AbstractButton';
import { setOverflowMenuVisible } from '../../toolbox/actions.web';
import { togglePiP } from '../actions';
/**
 * Toolbar button that toggles the floating Picture-in-Picture window.
 * The initial click provides the user gesture browsers require to enter PiP.
 *
 * @augments AbstractButton
 */
class PiPButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.pip';
    icon = IconScreenshare;
    label = 'toolbar.pip';
    toggledLabel = 'toolbar.exitPip';
    tooltip = 'toolbar.pip';
    /**
     * Handles clicking / pressing the button.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { _pipActive, dispatch } = this.props;
        sendAnalytics(createToolbarEvent('pip.button', { 'is_enabled': !_pipActive }));
        dispatch(togglePiP());
        dispatch(setOverflowMenuVisible(false));
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._pipActive;
    }
}
/**
 * Maps (parts of) the redux state to the associated props for the
 * {@code PiPButton} component.
 *
 * @param {Object} state - The Redux state.
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    return {
        _pipActive: Boolean(state['features/pip']?.isPiPActive)
    };
}
export default translate(connect(_mapStateToProps)(PiPButton));
